<template>
  <div class="sparklecloud-anime-android-container">
    <h1>元邦二次元小劇場 Android</h1>
  </div>
</template>

<script>
export default {
  name: 'SparkleCloudAnimeAndroid'
}
</script>

<style scoped>
.sparklecloud-anime-android-container {
  padding: 20px;
  text-align: center;
}

h1 {
  color: #3ddc84;
  margin-bottom: 20px;
}
</style>
